module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"total_count":"検出数: {count}"},"en":{"total_count":"Detections: {count}"}}')
  delete Component.options._Ctor
}
